import { render, staticRenderFns } from "./active_patients.vue?vue&type=template&id=176af373&scoped=true&"
import script from "./active_patients.vue?vue&type=script&lang=js&"
export * from "./active_patients.vue?vue&type=script&lang=js&"
import style0 from "./active_patients.vue?vue&type=style&index=0&id=176af373&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176af373",
  null
  
)

export default component.exports